import { PageHeader } from 'ui/pageHeader';
import { LinkButton } from 'ui/linkButton';
import { AddNew16 } from 'ui/icons/aurora/16px/AddNew16';
import { useFacebookLoginContext } from '../contexts/FacebookLoginContext';
import { useFbcaTranslations } from '../hooks/useTranslations';

const FACEBOOK_INTEGRATION_DOC = 'https://support.iterable.com/hc/articles/115005019663';

export const FacebookIntegrationsHeader = () => {
  const { loginCode, facebookLoginUrl } = useFacebookLoginContext();
  const { t } = useFbcaTranslations();
  const buttonText = loginCode ? t('header.add') : t('header.connect');

  return (
    <PageHeader
      data-test="header-container"
      documentation={{
        href: FACEBOOK_INTEGRATION_DOC,
        content: 'Documentation',
      }}
      pageActions={
        <LinkButton to={facebookLoginUrl} isAngular data-test="pageHeaderPrimaryAction">
          <AddNew16 />
          &nbsp;
          {buttonText}
        </LinkButton>
      }
    >
      {t('header.fbLabel')}
    </PageHeader>
  );
};
